import React from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "./IconButton";
import BackIcon from "./BackIcon";
import Tooltip from "./Tooltip";

function BackButton({ to, className = "" }) {
  const navigate = useNavigate();

  return (
    <Tooltip content="Back" position="top">
      <IconButton
        onClick={() => navigate(to)}
        variant="ghost"
        size="md"
        className={className}
        aria-label="Back"
      >
        <BackIcon />
      </IconButton>
    </Tooltip>
  );
}

export default BackButton;
